import { render, staticRenderFns } from "./MSettingsDebugQuestionnaires.vue?vue&type=template&id=081434f7&scoped=true"
import script from "./MSettingsDebugQuestionnaires.vue?vue&type=script&lang=ts"
export * from "./MSettingsDebugQuestionnaires.vue?vue&type=script&lang=ts"
import style0 from "./MSettingsDebugQuestionnaires.vue?vue&type=style&index=0&id=081434f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.37_css-loader@6.11.0_webpack@5.93.0__ejs@3.1.10_hoga_mqdlk73zogqfmm4uknw3a3yvy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081434f7",
  null
  
)

export default component.exports